import { render, staticRenderFns } from "./ManageRoleModal.vue?vue&type=template&id=e1c9654a&"
import script from "./ManageRoleModal.vue?vue&type=script&lang=js&"
export * from "./ManageRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports